/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TipoPraticaCanaleComunicazioneDTO } from '../model/models';
import { TipoPraticaCanaleComunicazionePatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListTipoPraticaCanaliComunicazioneRequestParams {
    idTipoPratica: string;
    idEvento: string;
}

export interface PatchTipoPraticaCanaleComunicazioneRequestParams {
    idTipoPratica: string;
    idEvento: string;
    idCanale: string;
    tipoPraticaCanaleComunicazionePatchForm: TipoPraticaCanaleComunicazionePatchForm;
}


export interface TipoPraticaCanaleComunicazioneControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista dei 3 canali di un evento (EMAIL/SMS/WA)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/{idEvento}/canali
* @param requestParameters
     */
    listTipoPraticaCanaliComunicazione(requestParameters: ListTipoPraticaCanaliComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<Array<TipoPraticaCanaleComunicazioneDTO>>;

    /**
     * Patch del canale: toggle abilitato e/o edit testo (richiede version)
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/{idEvento}/canali/{idCanale}
* @param requestParameters
     */
    patchTipoPraticaCanaleComunicazione(requestParameters: PatchTipoPraticaCanaleComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaCanaleComunicazioneDTO>;

}
